import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import { isInteger, hideWhenDisplaying, editable, inlineEdit } from 'src/types/columnFlags';
const controlledActions = {
    create: [267],
    fetch: [268],
    update: [269],
    delete: [270],
    downloadList: [-1],
    uploadList: [-1]
};
const columns = (state, getters, rootState, rootGetters) => {
    return [
        { name: 'row_menu', type: 'row_menu', menuItemShortcuts: ['delete'] },
        { name: 'id', style: 'width:80px', isInteger, hideWhenDisplaying },
        { name: 'source_of_native_id', label: 'Source of native ID', references: [...rootState['orgs.orgs'].list, { id: 1907, name: 'Legion' }, { id: 741, name: 'Mariana Tek' }, { id: 1868, name: 'UltiPro' }], editable },
        { name: 'native_id', label: 'Native ID', isInteger, inlineEdit }
    ];
};
const localEntity = constructLocalEntity({
    // @ts-ignore
    columns,
    remoteEntityName: 'users.users_native_ids',
    apiVersion: 1,
    controlledActions,
    pageTitle: 'User native IDs'
});
export default localEntity;
